(function () {
  var SECTION_SELECTOR = '.oddit-section-testimonials';
  var sectionState = new Map();

  var HIDDEN_ARROW_CLASS = 'oddit-section-testimonials__arrow--hidden';

  // Pagination works in "pages" — one page is a single viewport-width of the
  // scrollable track — so the dots reflect how many scroll stops exist, not how
  // many cards there are. On a wide viewport several cards share one page.
  function getPageMetrics(track) {
    var pageSize = track.clientWidth;
    var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
    var count = 1;
    if (pageSize > 0 && maxScroll > 0) {
      count = Math.ceil(maxScroll / pageSize) + 1;
    }
    return { pageSize: pageSize, maxScroll: maxScroll, count: count };
  }

  function getCurrentPage(track) {
    var m = getPageMetrics(track);
    if (m.pageSize <= 0) return 0;
    // At (or within 2px of) the end, the last page can't advance a full width,
    // so clamp to the final page rather than rounding short of it.
    if (m.maxScroll > 0 && track.scrollLeft >= m.maxScroll - 2) {
      return m.count - 1;
    }
    var page = Math.round(track.scrollLeft / m.pageSize);
    return Math.max(0, Math.min(page, m.count - 1));
  }

  function scrollToPage(track, page) {
    var m = getPageMetrics(track);
    var clamped = Math.max(0, Math.min(page, m.count - 1));
    // The final page snaps to the true max scroll (the last page is usually a
    // partial width), every earlier page is an exact multiple of the width.
    var left = clamped >= m.count - 1 ? m.maxScroll : clamped * m.pageSize;
    track.scrollTo({ left: left, behavior: 'smooth' });
  }

  function updateIndicators(section, activePage) {
    var indicators = section.querySelectorAll('.oddit-section-testimonials__indicator');
    indicators.forEach(function (dot, index) {
      var isActive = index === activePage;
      dot.classList.toggle('oddit-section-testimonials__indicator--active', isActive);
      dot.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function updateArrows(section, page, count) {
    var prev = section.querySelector('[data-testimonials-prev]');
    var next = section.querySelector('[data-testimonials-next]');
    // Prev only appears once you've left the first page; next disappears on the
    // last page.
    if (prev) prev.classList.toggle(HIDDEN_ARROW_CLASS, page <= 0);
    if (next) next.classList.toggle(HIDDEN_ARROW_CLASS, page >= count - 1);
  }

  // Sync the active dot and arrow visibility to the current scroll position.
  function updateControls(section, track) {
    var page = getCurrentPage(track);
    var count = getPageMetrics(track).count;
    updateIndicators(section, page);
    updateArrows(section, page, count);
  }

  // (Re)build the dot buttons so their number matches the current page count,
  // which changes with viewport width. Only rebuilds when the count changed.
  function buildIndicators(section, track, state) {
    var container = section.querySelector('[data-testimonials-indicators]');
    if (!container) return;
    var count = getPageMetrics(track).count;
    var existing = container.querySelectorAll('.oddit-section-testimonials__indicator');
    if (existing.length === count) return;

    container.innerHTML = '';
    for (var i = 0; i < count; i++) {
      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'oddit-section-testimonials__indicator';
      dot.setAttribute('role', 'tab');
      dot.setAttribute('aria-label', 'Go to page ' + (i + 1));
      dot.setAttribute('aria-selected', 'false');
      dot.setAttribute('data-testimonials-indicator', String(i));
      (function (target) {
        dot.addEventListener('click', function () {
          scrollToPage(track, target);
          updateControls(section, track);
          if (state.autoplay) state.autoplay.disableAutoplayPermanently();
        });
      })(i);
      container.appendChild(dot);
    }
    // Hide the whole dot bar when everything fits on one page.
    container.style.display = count <= 1 ? 'none' : '';
  }

  function initAutoplay(section, track) {
    var autoplayEnabled = section.dataset.autoplay === 'true';
    if (!autoplayEnabled) return null;

    var speedSeconds = parseInt(section.dataset.autoplaySpeed, 10) || 5;
    var intervalMs = speedSeconds * 1000;
    var rafId = null;
    var lastAdvance = performance.now();
    var userHasTakenControl = false;

    function disableAutoplayPermanently() {
      if (userHasTakenControl) return;
      userHasTakenControl = true;
      stop();
    }

    function tick(now) {
      if (userHasTakenControl) return;
      if (now - lastAdvance >= intervalMs) {
        var total = getPageMetrics(track).count;
        var current = getCurrentPage(track);
        var next = (current + 1) % total;
        scrollToPage(track, next);
        updateControls(section, track);
        lastAdvance = now;
      }
      rafId = requestAnimationFrame(tick);
    }

    function start() {
      if (userHasTakenControl) return;
      if (rafId) return;
      lastAdvance = performance.now();
      rafId = requestAnimationFrame(tick);
    }

    function stop() {
      if (rafId) {
        cancelAnimationFrame(rafId);
        rafId = null;
      }
    }

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reducedMotion.matches) {
      return {
        start: function () {},
        stop: function () {},
        destroy: function () {},
        disableAutoplayPermanently: function () {}
      };
    }

    document.addEventListener('visibilitychange', function () {
      if (userHasTakenControl) return;
      document.hidden ? stop() : start();
    });

    track.addEventListener('mouseenter', function () {
      if (!userHasTakenControl) stop();
    });
    track.addEventListener('mouseleave', function () {
      if (!userHasTakenControl) start();
    });

    // User intent is detected from the gestures themselves, never from `scroll` —
    // autoplay's own smooth scroll emits those for ~400ms and would read as the
    // user taking over. Wheel covers trackpad/shift-scroll; touch, focus, arrows,
    // dots and drag each disable autoplay at their own source.
    track.addEventListener('focusin', disableAutoplayPermanently);
    track.addEventListener('touchstart', disableAutoplayPermanently, { passive: true });
    track.addEventListener('wheel', disableAutoplayPermanently, { passive: true });

    reducedMotion.addEventListener('change', function (e) {
      if (userHasTakenControl) return;
      e.matches ? stop() : start();
    });

    start();

    return {
      start: start,
      stop: stop,
      destroy: stop,
      disableAutoplayPermanently: disableAutoplayPermanently
    };
  }

  function initDragScroll(section, track, state) {
    var DRAG_CLASS = 'oddit-section-testimonials__track--dragging';
    var DRAG_THRESHOLD = 5; // px of movement before a press becomes a drag
    var pointerFine = window.matchMedia('(hover: hover) and (pointer: fine)');

    var isDown = false;
    var isDragging = false;
    var suppressClick = false;
    var startX = 0;
    var startScroll = 0;
    var activePointerId = null;

    function onPointerDown(e) {
      // Only hijack mouse input; touch/pen keep native momentum scrolling.
      if (e.pointerType !== 'mouse' || e.button !== 0) return;
      if (!pointerFine.matches) return;
      isDown = true;
      isDragging = false;
      startX = e.clientX;
      startScroll = track.scrollLeft;
      activePointerId = e.pointerId;
    }

    function onPointerMove(e) {
      if (!isDown || e.pointerId !== activePointerId) return;
      var dx = e.clientX - startX;
      if (!isDragging) {
        if (Math.abs(dx) < DRAG_THRESHOLD) return;
        isDragging = true;
        track.classList.add(DRAG_CLASS);
        try {
          track.setPointerCapture(activePointerId);
        } catch (err) {}
        if (state.autoplay) state.autoplay.disableAutoplayPermanently();
      }
      e.preventDefault();
      track.scrollLeft = startScroll - dx;
    }

    function endDrag(e) {
      if (!isDown) return;
      if (e && activePointerId !== null && e.pointerId !== activePointerId) return;
      isDown = false;
      if (activePointerId !== null) {
        try {
          track.releasePointerCapture(activePointerId);
        } catch (err) {}
      }
      activePointerId = null;
      if (isDragging) {
        isDragging = false;
        suppressClick = true;
        track.classList.remove(DRAG_CLASS);
        // Restore smooth behaviour + snap to the nearest page.
        var page = getCurrentPage(track);
        scrollToPage(track, page);
        updateControls(section, track);
      }
    }

    // A click fires after the drag's pointerup — swallow it so cards/links
    // inside the track don't activate at the end of a drag gesture.
    function onClickCapture(e) {
      if (!suppressClick) return;
      suppressClick = false;
      e.preventDefault();
      e.stopPropagation();
    }

    // Stop the browser's native image/text drag from stealing the gesture.
    function onDragStart(e) {
      if (isDown) e.preventDefault();
    }

    track.addEventListener('pointerdown', onPointerDown);
    track.addEventListener('pointermove', onPointerMove);
    track.addEventListener('pointerup', endDrag);
    track.addEventListener('pointercancel', endDrag);
    track.addEventListener('pointerleave', endDrag);
    track.addEventListener('click', onClickCapture, true);
    track.addEventListener('dragstart', onDragStart);

    return {
      destroy: function () {
        track.removeEventListener('pointerdown', onPointerDown);
        track.removeEventListener('pointermove', onPointerMove);
        track.removeEventListener('pointerup', endDrag);
        track.removeEventListener('pointercancel', endDrag);
        track.removeEventListener('pointerleave', endDrag);
        track.removeEventListener('click', onClickCapture, true);
        track.removeEventListener('dragstart', onDragStart);
        track.classList.remove(DRAG_CLASS);
      }
    };
  }

  function debounce(fn, wait) {
    var timerId = null;
    return function () {
      var context = this;
      var args = arguments;
      clearTimeout(timerId);
      timerId = setTimeout(function () {
        fn.apply(context, args);
      }, wait);
    };
  }

  function initSection(section) {
    var track = section.querySelector('.oddit-section-testimonials__track');
    if (!track) return;

    var state = {
      autoplay: null,
      handlers: {}
    };

    // Sync the active dot + arrow visibility when the user scrolls the track
    var handleScroll = debounce(function () {
      updateControls(section, track);
    }, 100);
    track.addEventListener('scroll', handleScroll, { passive: true });
    state.handlers.scroll = handleScroll;

    // Prev / next arrows step one page at a time
    var prevBtn = section.querySelector('[data-testimonials-prev]');
    var nextBtn = section.querySelector('[data-testimonials-next]');

    function handlePrev() {
      scrollToPage(track, getCurrentPage(track) - 1);
      updateControls(section, track);
      if (state.autoplay) state.autoplay.disableAutoplayPermanently();
    }

    function handleNext() {
      scrollToPage(track, getCurrentPage(track) + 1);
      updateControls(section, track);
      if (state.autoplay) state.autoplay.disableAutoplayPermanently();
    }

    if (prevBtn) prevBtn.addEventListener('click', handlePrev);
    if (nextBtn) nextBtn.addEventListener('click', handleNext);
    state.handlers.prev = handlePrev;
    state.handlers.next = handleNext;

    // Build the page dots and sync all controls to the starting position
    buildIndicators(section, track, state);
    updateControls(section, track);

    // Recompute page count / controls when the viewport (and card visibility)
    // changes, then re-snap to the current page.
    var handleResize = debounce(function () {
      buildIndicators(section, track, state);
      scrollToPage(track, getCurrentPage(track));
      updateControls(section, track);
    }, 150);
    window.addEventListener('resize', handleResize);
    state.handlers.resize = handleResize;

    // Initialize autoplay
    state.autoplay = initAutoplay(section, track);

    // Enable desktop click-and-drag scrolling
    state.drag = initDragScroll(section, track, state);

    sectionState.set(section, state);
  }

  function destroySection(section) {
    var state = sectionState.get(section);
    if (!state) return;
    if (state.autoplay) state.autoplay.destroy();
    if (state.drag) state.drag.destroy();
    if (state.handlers && state.handlers.resize) {
      window.removeEventListener('resize', state.handlers.resize);
    }
    sectionState.delete(section);
  }

  function init() {
    document.querySelectorAll(SECTION_SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    var section = e.target.querySelector(SECTION_SELECTOR);
    if (section) destroySection(section);
  });
})();